/* Shared mobile benefits slider. Each rendered bar owns its own dot controls. */
(function () {
  'use strict';
  function init(root) {
    var bars = [];
    if (root.matches && root.matches('.rdl-benefits')) bars.push(root);
    if (root.querySelectorAll) bars = bars.concat(Array.prototype.slice.call(root.querySelectorAll('.rdl-benefits')));
    bars.forEach(function (bar) {
      if (bar.dataset.rdlBenefitsInit === 'true') return;
      var track = bar.querySelector('.rdl-benefits__track');
      var items = Array.prototype.slice.call(bar.querySelectorAll('.rdl-benefits__item'));
      var dots = Array.prototype.slice.call(bar.querySelectorAll('.rdl-benefits__dot'));
      if (!track || items.length !== dots.length) return;
      bar.dataset.rdlBenefitsInit = 'true';
      function closestIndex() {
        var offset = track.scrollLeft;
        var nearest = 0, distance = Infinity;
        items.forEach(function (item, i) {
          var d = Math.abs(item.offsetLeft - items[0].offsetLeft - offset);
          if (d < distance) {distance = d; nearest = i;}
        });
        return nearest;
      }
      function updateDots() {
        var current = closestIndex();
        dots.forEach(function (dot, i) {
          var active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var to = items[i].offsetLeft - items[0].offsetLeft;
          track.scrollTo({
            left: to,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
          dots.forEach(function (button, j) {
            button.classList.toggle('is-active', j === i);
            button.setAttribute('aria-current', j === i ? 'true' : 'false');
          });
        });
      });
      track.addEventListener('scroll', updateDots, {passive:true});
      window.addEventListener('resize', updateDots, {passive:true});
      updateDots();
    });
  }
  function start() {init(document);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', function (event) {init(event.target);});
})();
